import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import BackMethods from "../../back_component/BackMethods";
import User from "../../models/User";

export default function LoginPage() {
  const { backEnd_request, setToken } = BackMethods();

  const [user, setUser] = useState(new User());
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (field, value) => {
    setUser((prev) => new User({ ...prev, [field]: value }));
    // مسح أخطاء التحقق عند البدء بالكتابة لتجنب تجميد الواجهة
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: null }));
    if (formError) setFormError("");
  };

  const validate = () => {
    const newErrors = {};
    if (!user.username?.trim()) newErrors.userName = "الرجاء إدخال اسم المستخدم";
    if (!user.password?.trim()) newErrors.password = "الرجاء إدخال كلمة المرور";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    // منع إعادة تحميل الصفحة نهائياً
    if (e) e.preventDefault();

    setFormError("");
    if (!validate()) return;

    setIsSubmitting(true);
    try {
      const res = await backEnd_request.post("auth/login", user.toLoginApi());

      if (res.data && res.data.user && res.data.user.userType === "Web") {
        setToken(res.data);
      } else {
        setFormError("ليس لديك صلاحية الوصول لوحة التحكم");
      }
    } catch (error) {
      console.error("Login Error:", error);
      // التحقق مما إذا كان السيرفر أرسل رسالة خطأ محددة
      const message = error.response?.data?.message || "اسم المستخدم أو كلمة المرور غير صحيحة";
      setFormError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const togglePassword = (e) => {
    e.preventDefault(); // منع الزر من إرسال الفورم
    setShowPassword(!showPassword);
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: "linear-gradient(135deg, #0f1114 0%, #212529 100%)",
        direction: "rtl"
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-6 col-lg-4">

            <div className="text-center mb-4 animate-fade-in">
              <img
                src="/website-icon.png"
                alt="Logo"
                className="mb-3"
                style={{ width: "100px", height: "auto", filter: "drop-shadow(0 5px 15px rgba(0,0,0,0.3))" }}
              />
              <h2 className="text-white fw-bold mb-2">حماية المستهلك وسلامة الغذاء</h2>
              <p className="text-white-50 small">الجمهورية العربية السورية</p>
            </div>

            <div
              className="card border-0 shadow-lg"
              style={{
                borderRadius: "24px",
                background: "rgba(255, 255, 255, 0.05)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 255, 255, 0.1)"
              }}
            >
              <div className="card-body p-4 p-md-5">
                <h4 className="text-white text-center mb-4 fw-bold">تسجيل الدخول</h4>

                {/* رسائل الخطأ تظهر هنا بوضوح قبل الفورم أو بعده */}
                {formError && (
                  <div className="alert alert-danger py-2 small text-center border-0 mb-4" style={{ borderRadius: "10px", backgroundColor: "rgba(220, 53, 69, 0.2)", color: "#ff8a8a" }}>
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    {formError}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="text-white-50 small mb-2 ms-2">اسم المستخدم</label>
                    <input
                      type="text"
                      className={`form-control bg-dark text-white border-secondary ${errors.userName ? "is-invalid" : ""}`}
                      placeholder="أدخل اسم المستخدم"
                      value={user.username || ""}
                      onChange={(e) => handleChange("username", e.target.value)}
                      style={{ borderRadius: "12px", padding: "12px", border: "1px solid #444" }}
                    />
                    {errors.userName && <div className="invalid-feedback">{errors.userName}</div>}
                  </div>

                  <div className="mb-4 position-relative">
                    <label className="text-white-50 small mb-2 ms-2">كلمة المرور</label>
                    <div className="position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        className={`form-control bg-dark text-white border-secondary ${errors.password ? "is-invalid" : ""}`}
                        placeholder="••••••••"
                        value={user.password || ""}
                        onChange={(e) => handleChange("password", e.target.value)}
                        style={{ borderRadius: "12px", padding: "12px", paddingLeft: "45px" }}
                      />
                      <button
                        type="button" // مهم جداً لمنع عمل submit
                        onClick={togglePassword}
                        className="position-absolute top-50 start-0 translate-middle-y ms-3 border-0 bg-transparent text-white-50"
                        style={{ zIndex: 5 }}
                      >
                        {showPassword ? <FaEye size={18} /> : <FaEyeSlash size={18} />}
                      </button>
                    </div>
                    {errors.password && <div className="invalid-feedback d-block">{errors.password}</div>}
                  </div>

                  <button
                    type="submit"
                    className="btn btn-info w-100 py-3 fw-bold shadow-sm mt-2"
                    style={{ borderRadius: "12px" }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        جاري التحقق...
                      </>
                    ) : (
                      "دخول للمنظومة"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        input.form-control:focus {
          background-color: #1a1d21 !important;
          border-color: #0dcaf0 !important;
          color: white !important;
        }
        .animate-fade-in { animation: fadeIn 0.8s ease-out; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </div>
  );
}